import { useEffect, useMemo, useState } from 'react';

import { SimpleHeader } from 'components/ui/SimpleHeader';
import { useAuth } from 'context/AuthContext';
import { HeaderElbb } from 'pages/HomeElbb/components';
import { fetchRuleElbb } from 'services/rule.service';

export function RegulamentoElbb() {
  const { isAuthenticated } = useAuth();
  const [ruleUrl, setRuleUrl] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [iframeError, setIframeError] = useState(false);

  useEffect(() => {
    async function loadRule() {
      try {
        const data = await fetchRuleElbb();
        const url = data?.regulation?.url;
        setRuleUrl(typeof url === 'string' ? url : '');
      } catch (error) {
        console.error('Erro ao carregar regulamento ELBB:', error);
        setRuleUrl('');
      } finally {
        setLoading(false);
      }
    }

    loadRule();
  }, []);

  const hasUrl = useMemo(() => Boolean(ruleUrl), [ruleUrl]);
  const canEmbed = hasUrl && !iframeError;

  return (
    <div className="min-h-screen bg-gray-100">
      {isAuthenticated ? (
        <HeaderElbb currentPage="regulamento" />
      ) : (
        <SimpleHeader title="Prêmio ELBB" subtitle="Regulamento" />
      )}

      <main className="max-w-[1200px] mx-auto px-4 py-6 md:py-8">
        <section className="bg-white rounded-xl border border-gray-200 p-6 md:p-8" aria-labelledby="regulamento-title">
          <h1 id="regulamento-title" className="text-2xl md:text-3xl font-bold text-blue-bb-6 mb-3">
            Regulamento ELBB
          </h1>

          <p className="text-gray-700 mb-6">
            Consulte o regulamento oficial do prêmio. Caso o conteúdo não carregue no quadro abaixo,
            utilize o botão para abrir em nova aba.
          </p>

          {loading ? (
            <div className="h-[70vh] min-h-[520px] rounded-lg border border-gray-200 bg-gray-50 flex items-center justify-center">
              <span className="text-blue-bb font-semibold">Carregando regulamento...</span>
            </div>
          ) : canEmbed ? (
            <div className="h-[70vh] min-h-[520px] rounded-lg border border-gray-200 overflow-hidden bg-white">
              <iframe
                src={ruleUrl}
                title="Regulamento ELBB"
                className="w-full h-full"
                onError={() => setIframeError(true)}
              />
            </div>
          ) : (
            <div className="h-[70vh] min-h-[360px] rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 flex items-center justify-center p-6 text-center">
              <div>
                <h2 className="text-xl font-semibold text-blue-bb-6 mb-2">Não foi possível exibir o regulamento no quadro.</h2>
                <p className="text-gray-700">
                  O conteúdo pode estar indisponível para visualização via iframe ou sem URL cadastrada.
                </p>
              </div>
            </div>
          )}

          {hasUrl ? (
            <div className="mt-6">
              <a
                href={ruleUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-md bg-yellow-bb text-blue-bb font-semibold px-5 py-3 hover:opacity-90 transition-opacity"
              >
                Abrir regulamento em nova aba
              </a>
            </div>
          ) : null}
        </section>
      </main>
    </div>
  );
}
